import type { BannerName, ButtonName, ModalName } from '@coursera/event-pulse-types';

/**
 * Analytics taxonomy for the Learners & Invitation surfaces (ENTADMIN-2220, M3 - FE Eventing
 * Requirements). Each constant holds the exact members of the matching
 * `@coursera/event-pulse-types` enum and is validated with `satisfies` so a value that drifts
 * from the SDK fails to compile. The SDK schema is the source of truth; these constants only
 * give the bundle readable, DRY names.
 */

export const LEARNERS_BUTTON = {
  INVITE_VIA_EMAIL: 'enterprise_admin_invite_via_email',
  INVITE_VIA_CSV: 'enterprise_admin_invite_via_csv',
  INVITE_VIA_DOMAIN: 'enterprise_admin_invite_via_domain',
  DOWNLOAD_CSV_TEMPLATE: 'enterprise_admin_download_csv_template',
  SEND_LEARNER_INVITES: 'enterprise_bulk_send_learner_invites',
  ADD_LEARNERS_TO_GROUP: 'enterprise_admin_add_learners_to_group',
  CREATE_GROUP_COMPLETE: 'enterprise_create_program',
  SKIP_GROUP_ASSIGNMENT: 'enterprise_admin_skip_group_assignment',
  EDIT_DOMAINS: 'enterprise_admin_edit_domains',
  REMOVE_DOMAIN: 'enterprise_admin_remove_domain',
  DOWNLOAD_INVITE_ERROR_REPORT: 'enterprise_admin_download_invite_error_report',
  ADD_TO_GROUP_START: 'enterprise_admin_add_to_group_start',
  SEND_MESSAGE: 'enterprise_admin_send_message',
  ASSIGN_CONTENT: 'enterprise_admin_assign_content',
  DOWNLOAD_LEARNERS: 'enterprise_admin_download_learners',
  REMOVE_LEARNERS_MODAL: 'enterprise_admin_remove_learners_modal',
  INVITE_CSV_CONTINUE_TO_GROUP: 'enterprise_admin_invite_csv_continue_to_group',
  INVITE_EMAIL_CONTINUE_TO_GROUP: 'enterprise_admin_invite_email_continue_to_group',
  INVITE_REUPLOAD_CSV: 'enterprise_admin_invite_reupload_csv',
} as const satisfies Record<string, ButtonName>;

export const LEARNERS_MODAL = {
  INVITE_RESULT: 'enterprise_admin_invite_result',
  INVITE_ASYNC: 'enterprise_admin_invite_async',
  INVITE_TO_GROUP_ASYNC: 'enterprise_admin_invite_to_group_async',
  ADD_TO_GROUP_ASYNC: 'enterprise_admin_add_to_group_async',
} as const satisfies Record<string, ModalName>;

export const LEARNERS_BANNER = {
  INVITE_CSV_ERROR: 'enterprise_admin_invite_csv_error',
} as const satisfies Record<string, BannerName>;
